import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from '../WizardStepTemplate/Content';
import metaOverrideSet from './metaOverrideSet';

export const AnnualInvestmentReviewInvestmentObjectivesRetirementAgeStepTemplate = ({
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
    />
  );
};

AnnualInvestmentReviewInvestmentObjectivesRetirementAgeStepTemplate.defaultProps = {
};

AnnualInvestmentReviewInvestmentObjectivesRetirementAgeStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
